// extracted by mini-css-extract-plugin
export default {"video-preview":"XJA4rm","videoPreview":"XJA4rm","heading":"jT41YF","xs":"AMY3jq","checklist-item":"wOpflR","checklistItem":"wOpflR","cta":"kK4tDL"};